import { render, staticRenderFns } from "./behsourcedialog.vue?vue&type=template&id=4cca8b10&scoped=true"
import script from "./behsourcedialog.vue?vue&type=script&lang=js"
export * from "./behsourcedialog.vue?vue&type=script&lang=js"
import style0 from "./behsourcedialog.vue?vue&type=style&index=0&id=4cca8b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca8b10",
  null
  
)

export default component.exports